import React, { Component } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Layout from '../components/layout';
import Logo from '../components/logo';
import IconArrowRight from '../assets/images/right-arrow.svg';
import Answer from '../components/answer';

class Quiz extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timeTimer: 10,
      timeElapsed: 0,
      answered: false,
      answerCorrect: false,
      answerSelected: 0,
      currentQuestion: 0,
      answersOptions: [],
      bgClass: 'bg-quiz',
      stats: [],
    }
  } 

  componentDidMount() {
    this.countTime();
    const questions = this.props.questions;

    if (questions && questions[this.state.currentQuestion]) {
      let shuffleOptions = [
        questions[this.state.currentQuestion].option1,
        questions[this.state.currentQuestion].option2,
        questions[this.state.currentQuestion].option3,
        questions[this.state.currentQuestion].option4,
      ]
      
      let options = shuffleOptions;
      this.setState({ answersOptions: options });
    }
  }

  countTime = () => {
    let countInterval = setInterval(() => {
      if (this.state.answered) {
        clearInterval(countInterval);
      } else {
        let timeElapsed = this.state.timeElapsed;
        timeElapsed += 1;
        this.setState({ timeElapsed });
      }
    }, 1000);
  }

  clickAnswerHandler = (option, isCorrect) => {
    const { currentQuestion, timeElapsed } = this.state;
    let stats = this.state.stats;
    // console.log('currentQuestion', currentQuestion);
    // console.log('question', this.props.questions[currentQuestion]);

    let stat = {};
    stat.question = this.props.questions[currentQuestion]._id;
    stat.responseTime = timeElapsed;
    stat.isCorrect = isCorrect;
    stat.points = this.calculatePoints(isCorrect, timeElapsed)
    stats.push(stat);

    this.setState({
      answered: true,
      answerSelected: option,
      answerCorrect: isCorrect,
      bgClass: isCorrect ? 'bg-blue' : 'bg-red',
      stats
    });
  }

  calculatePoints = (isCorrect, responseTime) => {
    const pointsCorrectAnswer = 10;
    const pointsBonusTime = 2;
    const timeExtraPoints = 10;
    const fraccion = timeExtraPoints / 4;
    let points = 0;
    if (isCorrect) {
      points = pointsCorrectAnswer;
      if (0 <= responseTime && responseTime <= fraccion) {
        points += pointsBonusTime * 4;
      }
      if (fraccion < responseTime && responseTime <= fraccion * 2) {
        points += pointsBonusTime * 3;
      }
      if (fraccion * 2 < responseTime && responseTime <= fraccion * 3) {
        points += pointsBonusTime * 2;
      }
      if (fraccion * 3 < responseTime && responseTime <= fraccion * 4) {
        points += pointsBonusTime;
      }
    }

    return points;
  }

  nextQuestionHandler = () => {
    let next = this.state.currentQuestion + 1;

    if (next < this.props.questions.length) {
      let options = [
        this.props.questions[next].option1,
        this.props.questions[next].option2,
        this.props.questions[next].option3,
        this.props.questions[next].option4
      ];

      let shuffleOptions = options.shuffle();
      // console.log('Respuestas mix:', shuffleOptions);

      this.setState({
        timeTimer: 10,
        timeElapsed: 0,
        answered: false,
        answerCorrect: false,
        answerSelected: 0,
        currentQuestion: next,
        bgClass: 'bg-quiz',
        answersOptions: shuffleOptions
      });
      this.countTime();
    } else {
      this.props.completeRound(this.state.stats);
    }
  }

  _renderTimer = () => {
    let timeProgress = this.state.timeTimer - this.state.timeElapsed;

    if (this.state.timeElapsed > 10) {
      return null;
    }

    return (
      <div className="quiz-timer">
        <CircularProgressbar 
          value={timeProgress * 10} 
          text={timeProgress}
          counterClockwise={true}
          strokeWidth={2}
          styles={{
            path: {
              stroke: '#ffffff',
            },
            trail: {
              stroke: 'rgba(0,0,0,0.1)',
            },
            text: {
              fontSize: '38px',
              fill: '#ffffff',
            }
          }}
        />
      </div>
    );
  }

  _renderFeedBack = () => {
    let cardDisplayClass = this.state.answered ? 'feedback-show' : 'feedback-hide';
    let cardColorClass = this.state.answerCorrect ? 'success' : 'error';
    let feedbackTitle = this.state.answerCorrect ? '¡Bien hecho!' : '¡Ups! no es la respuesta correcta';
    let feedbackMessage = this.state.answerCorrect
      ? this.props.questions[this.state.currentQuestion].feedbackCorrect
      : this.props.questions[this.state.currentQuestion].feedbackIncorrect;

    return (
      <div className={`card-feedback bounceInUp ${cardColorClass} ${cardDisplayClass}`}>
        <div className="card-feedback-header">
          <h3>{feedbackTitle}</h3>
        </div>
        <div className="card-feedback-body">
          <div className="container">
            <p>{feedbackMessage}</p>
            <div className="feedback-action">
              <button 
                type="button" 
                className="btn btn-feedback"
                onClick={this.nextQuestionHandler}
              >
                Continuar
                <img className="icon" src={IconArrowRight} alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _renderAnswers = () => {
    const { answerSelected, answered, timeElapsed, answersOptions, currentQuestion } = this.state;

    let options = answersOptions;
    if (!options.length) {
      options = [
        this.props.questions[currentQuestion].option4,
        this.props.questions[currentQuestion].option2,
        this.props.questions[currentQuestion].option1,
        this.props.questions[currentQuestion].option3
      ];
      options = options.shuffle();
    }

    return options.map((item, index) => {
      let selected = answered && answerSelected === index ? true : false;
      return (
        <Answer 
          key={index}
          answer={item}
          isSelected={selected}
          option={index}
          time={timeElapsed}
          disabled={answered}
          onClick={this.clickAnswerHandler}
        />
      );
    });
  }

  render() {
    const question = this.props.questions[this.state.currentQuestion];
    return (
      <Layout bgClass={this.state.bgClass}>
        <div className="container">
          <div className="quiz-header">
            <div className="row">
              <div className="col-12 col-md-5 col-lg-4">
                <Logo campaign={this.props.campaign.name} textAlign="left" />
              </div>
              <div className="col-6 col-md-4 col-lg-4">
                <h4 className="title-round">{`Ronda ${this.props.round}/3`}</h4>
              </div>
              <div className="col-6 col-md-3 col-lg-4">
                { this._renderTimer() }
              </div>
            </div>
          </div>
          <div className="question-box">
            <h3 className="question-title">{question.question}</h3>
            <div className="answers-box">
              { this._renderAnswers() }
            </div>
          </div>
        </div>
        {this._renderFeedBack()}
      </Layout>
    );
  }
}

export default Quiz;